"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SttOptionsButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], _extends({
    color: "secondary",
    disableRipple: true,
    size: "small"
  }, props), /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null));
}
var _default = SttOptionsButton;
exports["default"] = _default;